import { z } from 'zod';
import { PERMISSIONS, terraContract } from '@terra/shared-authorization';
import {
  SubmitFeedbackRequestSchema,
  SubmitFeedbackResponseSchema,
} from './copilot-feedback.schema';
import { COPILOT_FEEDBACK_PATH_NAME } from './copilot-feedback.constants';

export const CopilotFeedbackContract = terraContract
  .prefix(`/${COPILOT_FEEDBACK_PATH_NAME}`)
  .router({
    submitFeedback: terraContract
      .meta({
        permissions: [PERMISSIONS.VIEW_APPLICATIONS.name],
      })
      .route({
        method: 'POST',
        path: '/',
        summary: 'Submit Co-Pilot feedback',
        description:
          'Submit user feedback for Co-Pilot conversations including ratings and text feedback with optional screenshot',
        inputStructure: 'detailed',
      })
      .input(z.object({ body: SubmitFeedbackRequestSchema }))
      .output(SubmitFeedbackResponseSchema),
  });
